import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { touchTargetSx } from 'theme/touchTarget';

export const DialogCloseButton: React.FC<{ onClick?: () => void }> = ({
  onClick,
}) => (
  <IconButton
    aria-label="Close"
    size="small"
    sx={{ color: 'text.secondary', flexShrink: 0, ...touchTargetSx }}
    onClick={onClick}
  >
    <CloseIcon sx={{ fontSize: 16 }} />
  </IconButton>
);
